// Mapper: transporte LC_ListMonitoringPresentOut → dominio MonitoringPresentPage.

import type {
  LC_MonitoringPresentItem,
  LC_ListMonitoringPresentOut,
  MonitoringPresent,
  MonitoringPresentPage,
} from '../types/monitoringPresent.types';


export function mapMonitoringPresent(item: LC_MonitoringPresentItem): MonitoringPresent {
  return {
    rut: item.employeeTaxIdentificationNumber ?? '',
    fullName: item.fullName ?? '',
    statusCode: item.statusCode ?? '',
  };
}

export function mapMonitoringPresentPage(
  out: LC_ListMonitoringPresentOut,
): MonitoringPresentPage {
  return {
    items: (out.items ?? []).map(mapMonitoringPresent),
    totalRecords: out.pagination?.totalRecords ?? 0,
  };
}
